/**
 * @file FormGroupDescriptionSlot.tsx
 *
 * @fileoverview Displays the description for a given form group.
 */
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { useIntl } from 'react-intl';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';

interface FormGroupDescriptionSlotProps {
  /**
   * The form group.
   */
  group: Slottable<any>;
}

export default function FormGroupDescriptionSlot({
  group,
}: FormGroupDescriptionSlotProps) {
  const intl = useIntl();
  return (
    <WYSIWYGText
      format="filtered_html"
      content={
        group.description &&
        !!intl.messages &&
        intl.messages?.[`config_form_${group.key}_description`]
          ? (intl.messages[`config_form_${group.key}_description`] as any)
          : group.description
      }
    />
  );
}

export { FormGroupDescriptionSlot };
